import React from 'react';
import { InlineAlert } from '@xo-union/tk-component-alerts';
import { DisplayLink } from '@xo-union/tk-ui-links';
import styles from './errorMessage.scss';

const UnpublishedWWSErrorMessage: React.FunctionComponent = () => {
  const errorMessage = 'Heads up! No one will be able to RSVP until you have a Website.';
  const ctaMessage = 'Get Started';

  return (
    <InlineAlert type="warning">
      {errorMessage}
      <DisplayLink target="_blank" rel="noopener noreferrer" className={styles.yellowLink} href="/gs/dashboard">
        {ctaMessage}
      </DisplayLink>
    </InlineAlert>
  );
};

export default UnpublishedWWSErrorMessage;
